import { render } from "./ResumeManagement.vue?vue&type=template&id=0bc39d90&scoped=true"
import script from "./ResumeManagement.vue?vue&type=script&lang=js"
export * from "./ResumeManagement.vue?vue&type=script&lang=js"

import "./ResumeManagement.vue?vue&type=style&index=0&id=0bc39d90&scoped=true&lang=css"

import exportComponent from "E:\\work\\code\\ai-view\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc39d90"]])

export default __exports__